import script from "./vipTableView.vue?vue&type=script&setup=true&lang=ts"
export * from "./vipTableView.vue?vue&type=script&setup=true&lang=ts"

import "./vipTableView.vue?vue&type=style&index=0&id=049bd63c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-049bd63c"]])

export default __exports__